<template>
   <div class="row  bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "cor_in_prev_pol_details"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#CorrectionPrevPol"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Correction of Previous Policy Details</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="CorrectionPrevPol">
        <div class="risk row">
            <!--Previous Policy Number* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionOfPrevPolicyDetailData.previousPolicyNumber.visibility">
            <div class="row form-group">
              <float-label label="Previous Policy Number*" :fixed="isFloat(correctionOfPrevPolicyDetailData.previousPolicyNumber.value)"> 
                <input
                  v-model="correctionOfPrevPolicyDetailData.previousPolicyNumber.value"
                  v-evolvews="correctionOfPrevPolicyDetailData.previousPolicyNumber"
                  type="text"
                  maxlength="50"
                  v-on:keydown="alphaNumeric"
                  :class="{'bgc-error-field':correctionOfPrevPolicyDetailData.previousPolicyNumber.errorText !== '',}"
                  class="form-control"
                  placeholder="Previous Policy Number*"
                />
              </float-label>
               <span class="error-text" v-if="correctionOfPrevPolicyDetailData.previousPolicyNumber.errorText !== ''">
                    {{correctionOfPrevPolicyDetailData.previousPolicyNumber.errorText}}</span>
            </div>
          </div>
          <!--Previous Policy Number* ends-->
           <!--Previous Insurance Company Name* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="correctionOfPrevPolicyDetailData.previousInsuranceCompany.visibility">
            <div class="row form-group">
              <float-label label="Previous Insurance Company Name*" :fixed="isFloat(correctionOfPrevPolicyDetailData.previousInsuranceCompany.value)"> 
                <select
                  v-model="correctionOfPrevPolicyDetailData.previousInsuranceCompany.value"
                  v-evolvews="correctionOfPrevPolicyDetailData.previousInsuranceCompany"
                  :class="{'bgc-error-field':correctionOfPrevPolicyDetailData.previousInsuranceCompany.errorText !== '',}"
                  class="form-control"
                  placeholder="Previous Insurance Company Name*"
                >
                  <option disabled selected value>Previous Insurance Company Name*</option>
                  <option disabled value='' v-if='correctionOfPrevPolicyDetailData.previousInsuranceCompany.value == ""'>Previous Insurance Company Name*</option>
                  <option disabled :value='null' v-if='correctionOfPrevPolicyDetailData.previousInsuranceCompany.value == null'>Previous Insurance Company Name*</option>
                  <option v-for="reason in domainValues.initPreviousPolicyDetails.insuranceCompanies" :key="reason.code" :value="reason.code">{{reason.name}}</option>
                </select>
              </float-label>
               <span class="error-text" v-if="correctionOfPrevPolicyDetailData.previousInsuranceCompany.errorText !== ''">
                    {{correctionOfPrevPolicyDetailData.previousInsuranceCompany.errorText}}</span>
            </div>
          </div>
          <!--Previous Insurance Company Name* ends-->
           <!--Branch Address starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Branch Address" :fixed="isFloat(correctionOfPrevPolicyDetailData.branchAddress.value)"> 
                <input
                  v-model="correctionOfPrevPolicyDetailData.branchAddress.value"
                  v-evolvews="correctionOfPrevPolicyDetailData.branchAddress"
                  type="text"
                  class="form-control"
                  placeholder="Branch Address"
                />
              </float-label>
               <span class="error-text" v-if="correctionOfPrevPolicyDetailData.branchAddress.errorText !== ''">
                    {{correctionOfPrevPolicyDetailData.branchAddress.errorText}}</span>
            </div>
          </div> -->
          <!--Branch Address ends-->
        </div>
    </div>
    </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import functions from "@/../../masters/functions.js";
// import base from "@/../../masters/base.js";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
    name: "CorrectionOfPrevPolicyDetail",
    props: ["correctionOfPrevPolicyDetailData","domainValues","businessType"],
  components: {
    FloatLabel,
  },
  setup(props, context) {
    let state = reactive({});
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;
    const alphaNumeric = functions.alphaNumeric;
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.correctionOfPrevPolicyDetailData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      if(props.businessType !== 'NEW')
        context.parent.enableCalculatePremiumBtn('correctionOfPrevPolicyDetails');
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      alphaNumeric
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
};
</script>


